export const BASE_LIST_VIEW = "BaseListView";
export const BASE_DETAIL_VIEW = "BaseDetailView";
export const CAMPAIGN_LIST = "CampaignList";
export const LEADS_LIST = "Leads";
export const CAMPAIGN_Details = "CampaignDetails";
export const DASHBOARD = "Dashboard";
export const EDIT_EMAIL = "EditEmail";
export const INTEGRATIONS = "Integrations";